import { useNavigate } from "react-router-dom";
import { useState } from "react";

const ResetPassword = () => {
const [password, setPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [error, setError] = useState("");

const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
        setError("Les mots de passe ne correspondent pas !");
    } else {
        setError("");
        alert("Mot de passe validé !");
        // Ici, tu peux envoyer le mot de passe au serveur
    }
};
}
    const Signup = () => {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    const [client, setClient] = useState({
        prenom: "",
        nom: "",
        email: "",
        adresse: "",
        telephone: "",
        motDePasse: "",
        confirmPassword: "",
    });

    // Gestion du changement des inputs
    const handleChange = (e) => {
        setClient({ ...client, [e.target.name]: e.target.value });
    };

    // Gestion du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Formulaire soumis");

        if (!client.email.includes("@")) {
            setError("L'adresse e-mail doit être valide.");
            return;
        }

        if (client.motDePasse !== client.confirmPassword) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }

        setError(""); // Réinitialisation de l'erreur

        try {
            const response = await fetch("http://localhost:8080/clients/register", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(client),
            });

            if (response.ok) {
               
                setMessage("Votre compte a bien été crée !");
                setClient({ prenom: "", nom: "", email: "", adresse: "", telephone: "", motDePasse: "", confirmPassword: "" });
            } else {
                setMessage("Erreur lors de l'ajout du client.");
            }
        } catch (error) {
            setMessage("Erreur de connexion avec le serveur.");
        }
    };

    return (
        <div className="w-full h-screen flex flex-col items-center justify-center bg-gray-100">
            {/* Navbar */}
            <nav className="bg-blue-600 text-white flex justify-between items-center px-6 py-4 w-full fixed top-0">
                <div className="text-lg font-bold">Logo et Nom</div>
                <div className="space-x-20">
                    <button onClick={() => navigate("/")} className="hover:underline text-[20px] cursor-pointer">
                        Accueil
                    </button>
                    <button onClick={() => navigate("/devis")} className="hover:underline text-[20px]">Devis</button>
                    <button className="hover:underline text-[20px]">Avis</button>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="flex flex-col items-start">
                        <button className="bg-red-500 px-6 py-2 rounded-md font-bold text-white">06 06 06 06 06</button>
                        <span className="mt-2 text-sm">Assistant client</span>
                    </div>
                </div>
            </nav>

            {/* Formulaire */}
            <div className="bg-white shadow-md rounded-lg p-6 w-96 mt-20">
                <h2 className="text-2xl font-bold text-center mb-6">Créer un compte</h2>
                <form className="flex flex-col space-y-5" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="prenom"
                        placeholder="Prénom"
                        value={client.prenom}
                        onChange={handleChange}
                        className="p-2 border rounded-md bg-gray-200"
                        required
                    />
                    <input
                        type="text"
                        name="nom"
                        placeholder="Nom"
                        value={client.nom}
                        onChange={handleChange}
                        className="p-2 border rounded-md bg-gray-200"
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Adresse Mail"
                        value={client.email}
                        onChange={handleChange}
                        className="p-2 border rounded-md bg-gray-200"
                        required
                    />
                    <input
                        type="text"
                        name="adresse"
                        placeholder="Adresse"
                        value={client.adresse}
                        onChange={handleChange}
                        className="p-2 border rounded-md bg-gray-200"
                        required
                    />
                    <input
                        type="text"
                        name="telephone"
                        placeholder="Téléphone"
                        value={client.telephone}
                        onChange={handleChange}
                        className="p-2 border rounded-md bg-gray-200"
                        required
                    />
                    <input
                        type="password"
                        name="motDePasse"
                        placeholder="Mot de passe"
                        value={client.motDePasse}
                        onChange={handleChange}
                        className="p-2 border rounded-md bg-gray-200"
                        required
                    />
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirmer votre mot de passe"
                        value={client.confirmPassword}
                        onChange={handleChange}
                        className="p-2 border rounded-md bg-gray-200"
                        required
                    />
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    {message && <p className="text-green-500 text-sm">{message}</p>}
                    <button type="submit" className="bg-black text-white py-2 rounded-md hover:bg-gray-800">
                        Créer un compte
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Signup;
